import { render } from "./SCreateButton.vue?vue&type=template&id=912c2072&ts=true"
import script from "./SCreateButton.ts?vue&type=script&lang=ts"
export * from "./SCreateButton.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__